import { FC, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ProductFilter } from './components/ProductFilter'
import { ProductForSearch } from './types'
import { useProductImageRecolor } from './hooks/useProductImageRecolor'

/**
 * Tela 1: Busca e Seleção de Produto
 * Padrão: Food SmartOrder
 * Rota: /product-image-recolor
 */
const ProductImageRecolorPage: FC = () => {
  const navigate = useNavigate()
  const { searchProducts, loading, error } = useProductImageRecolor()
  const [selectedProduct, setSelectedProduct] = useState<ProductForSearch | null>(null)

  const handleProductSelect = (product: ProductForSearch) => {
    setSelectedProduct(product)
    // ✅ NAVEGA PARA TELA 2 COM ID DO PRODUTO
    navigate(`/product-image-recolor/${product.id}`)
  }

  return (
    <div className='page'>
      {/* BREADCRUMB */}
      <div className='page-header d-print-none'>
        <div className='container-xl'>
          <div className='row align-items-center'>
            <div className='col'>
              <h2 className='page-title'>
                <i className='bi bi-palette me-2'></i>
                Recolorizar Imagens de Produtos
              </h2>
            </div>
          </div>
        </div>
      </div>

      {/* CONTEÚDO */}
      <div className='page-wrapper'>
        <div className='container-xl'>
          <div className='row'>
            <div className='col-12'>
              <ProductFilter
                onProductSelect={handleProductSelect}
                onSearch={searchProducts}
                loading={loading}
                error={error}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProductImageRecolorPage
